import React, { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
// material
import {
  Theme, useTheme
} from '@mui/material/styles';// hooks
import { Select, Box, Divider, MenuItem, Typography, TextField, useMediaQuery, IconButton, SelectChangeEvent, Fade } from '@mui/material';
import { BackendData } from '../../utils/backendDataParser';
import useLocalStorage from '../../hooks/useLocalStorage';
import MenuPopover from '../../components/commonComponents/MenuPopover';
import useLocales from '../../hooks/useLocales';

// components


// ----------------------------------------------------------------------

export default function ClientSelectorPopover() {
  const theme = useTheme<Theme>();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { translate } = useLocales();

  const xsDown = useMediaQuery<Theme>((theme) => theme.breakpoints.down('xs'));

  const [clients] = useLocalStorage<BackendData[]>('clientOptions', []);
  const [selectedClient, setSelectedClient] = useLocalStorage<(BackendData | undefined)>('selectedClient', undefined);

  const selectedIndex = clients.findIndex((backendData: BackendData) => backendData.name == selectedClient.name);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClientChange = (event: SelectChangeEvent<any>, child: React.ReactNode) => {
    const index = event.target.value as number;
    setSelectedClient(clients[index]);
    handleClose();
    window.location.reload();
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        style={{
          padding: 0,
          width: 140,
          ...xsDown && {
            width: 100,
          },
          height: 44,
          alignItems: 'center',
          marginRight: theme.spacing(2),
          ...open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              //   backgroundColor: Fade(theme.palette.grey[900], 0.72)
            }
          }
        }}
      >
        <TextField
          id="clientSelector"
          label={translate('Common.Client')}
          type="text"
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          defaultValue={selectedClient.name}
          InputProps={{ readOnly: true }}
          fullWidth
          size="small"
        />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        style={{ width: 220 }}
      >
        <Box style={{
          marginTop: theme.spacing(1.5),
          marginBottom: theme.spacing(1.5),
          paddingLeft: theme.spacing(2.5),
          paddingRight: theme.spacing(2.5),
        }}>
          <Typography variant="subtitle1" noWrap>
            {translate('Common.SelectClient')}
          </Typography>
        </Box>

        <Divider style={{
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1),
        }} />

        <Box style={{
          marginTop: theme.spacing(1.5),
          marginBottom: theme.spacing(1.5),
          paddingLeft: theme.spacing(2.5),
          paddingRight: theme.spacing(2.5),
        }}>
          <Select labelId="clients-label" id="clients"
            value={selectedIndex}
            fullWidth
            onChange={handleClientChange}>
            {clients.map((client: BackendData, index: number) => (
              <MenuItem key={index} value={index}>{client.name}</MenuItem>
            ))}
          </Select>
        </Box>
      </MenuPopover>
    </>
  );
}
